/**
 * Utilitários para trabalhar com cookies HttpOnly
 *
 * IMPORTANTE: Com cookies HttpOnly, não podemos acessar os cookies via JavaScript
 * por questões de segurança. Isso é uma boa prática!
 *
 * O backend gerencia os cookies automaticamente:
 * - Login: Define cookies HttpOnly
 * - Refresh: Atualiza cookies HttpOnly
 * - Logout: Remove cookies HttpOnly
 */

// Função para verificar se temos indicação local de autenticação
export const hasLocalAuthIndicator = (): boolean => {
  return !!localStorage.getItem("hasValidToken");
};

// Função para marcar como autenticado localmente
export const setLocalAuthIndicator = (): void => {
  localStorage.setItem("hasValidToken", "true");
};

// Função para remover indicação local de autenticação
export const clearLocalAuthIndicator = (): void => {
  localStorage.removeItem("hasValidToken");
};

// Função para verificar se estamos em ambiente de desenvolvimento
export const isDevelopment = (): boolean => {
  return import.meta.env.DEV;
};

// Função para log de debug apenas em desenvolvimento
export const debugLog = (message: string, ...args: any[]): void => {
  if (isDevelopment()) {
    // logger.info(`[Auth Debug] ${message}`, ...args);
  }
};

// Função para verificar se o navegador suporta cookies
export const cookiesSupported = (): boolean => {
  return navigator.cookieEnabled;
};

// Função para verificar se estamos em contexto seguro (HTTPS)
export const isSecureContext = (): boolean => {
  return (
    window.location.protocol === "https:" ||
    window.location.hostname === "localhost"
  );
};

// Função para obter informações do ambiente
export const getEnvironmentInfo = () => {
  return {
    isDev: isDevelopment(),
    cookiesEnabled: cookiesSupported(),
    isSecure: isSecureContext(),
    userAgent: navigator.userAgent,
    url: window.location.href,
  };
};

// Função para diagnosticar problemas de autenticação
export const diagnoseAuthIssues = (): string[] => {
  const issues: string[] = [];

  if (!cookiesSupported()) {
    issues.push("Cookies não estão habilitados no navegador");
  }

  if (!isSecureContext() && !isDevelopment()) {
    issues.push("Contexto não seguro (HTTPS necessário em produção)");
  }

  if (!hasLocalAuthIndicator()) {
    issues.push("Nenhum indicador local de autenticação encontrado");
  }

  return issues;
};
